import { render, staticRenderFns } from "./CustomerPage.vue?vue&type=template&id=01f6f182&scoped=true&lang=html"
import script from "./CustomerPage.vue?vue&type=script&lang=js"
export * from "./CustomerPage.vue?vue&type=script&lang=js"
import style0 from "./CustomerPage.vue?vue&type=style&index=0&id=01f6f182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f6f182",
  null
  
)

export default component.exports